export { default } from './OrbitSix';
